var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5438 43.2141C16.4535 40.7635 15.8457 38.0371 15.8457 35.1641C15.8457 24.4937 24.2301 15.8438 34.5728 15.8438C44.9157 15.8438 53.2999 24.4937 53.2999 35.1641C53.2999 38.0371 52.692 40.7635 51.6018 43.2141",
    stroke: "white",
    strokeWidth: 4.32164,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5732 5.76172V8.64281",
    stroke: "white",
    strokeWidth: 4.32164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.384 34.5703H60.5029",
    stroke: "white",
    strokeWidth: 4.32164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64281 34.5703H5.76172",
    stroke: "white",
    strokeWidth: 4.32164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9435 14.2031L52.9062 16.2404",
    stroke: "white",
    strokeWidth: 4.32164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2404 16.2404L14.2031 14.2031",
    stroke: "white",
    strokeWidth: 4.32164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8228 55.6257C44.7338 54.6842 45.9012 52.0197 46.2297 49.3397C46.3277 48.5391 45.669 47.875 44.8623 47.875L24.4205 47.8756C23.5862 47.8756 22.9161 48.5837 23.0157 49.4121C23.3374 52.0869 24.1493 54.0408 27.2342 55.6257M41.8228 55.6257C41.8228 55.6257 27.742 55.6257 27.2342 55.6257M41.8228 55.6257C41.4727 61.2294 39.8544 63.4488 34.5906 63.3865C28.9604 63.4905 27.6652 60.7474 27.2342 55.6257",
    stroke: "white",
    strokeWidth: 4.32164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.ed71408acff275e02c4991b13699550f.svg";
export { ForwardRef as ReactComponent };